import api from "../../../../utils/api";
import { NumberNull, PresencaBatismo } from "../../../../types";
import { useCallback, useState } from "react";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";

interface GetPresencaBatismo {

}

export type ResponsePresencaBatismo = {
  listAll: PresencaBatismo[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: PresencaBatismo[]
  pagina: number,
  pesquisaPorMinisterio: string,
  getSearchPerMinisterio: (event: any) => void
  refecth: () => Promise<void>
}

export type ParamsWith = { idevento: NumberNull, idsubevento: NumberNull, presenca?: boolean }

const GetPresencaBatismo = (): ResponsePresencaBatismo => {

  const { setErrorSuccess } = useErrorSuccess()

  const [listCheckinMembros, setListCheckinMembros] = useState<PresencaBatismo[]>([]);
  const [resetar, setResetar] = useState<boolean>(false);
  const [list, setList] = useState<PresencaBatismo[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const [params, setParams] = useState<{idevento: number, idsubevento: number, presenca: boolean}>();

  const [pesquisaPorMinisterio, setPesquisaPorMinisterio] = useState<string>('');

  const alterParams = (field: 'idevento' | 'idsubevento' | 'presenca', value: any) => {
    setParams((parm) => ({...parm, [field]: value}));
  }

  const getSearchPerMinisterio = (event: any) => setPesquisaPorMinisterio(event?.target?.value);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = useCallback(() => {
    setResetar(!resetar);
  }, [resetar])

  const getWithParams = useCallback(({ idevento, idsubevento, presenca }: ParamsWith) => {

    if (!idevento) {
      setErrorSuccess({ mensagem: 'Evento não passado', status: 'warning' });
      return;
    }

    if (!idsubevento) {
      setErrorSuccess({ mensagem: 'SubEvento não passado', status: 'warning' });
      return;
    }

    alterParams('idevento', idevento);
    alterParams('idsubevento', idsubevento);
    alterParams('presenca', presenca);

    api.get<PresencaBatismo[]>(`view/presencabusca/1/${idevento}/${idsubevento}`)
      .then(
        (sucesso) => {
          if (presenca) {
            /*@ts-ignore */
            setListCheckinMembros(sucesso?.data?.filter(el => el?.presenca));
            setPagina(1);
            return;
          }
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, [])

  const refecth = async () => {
    await api.get<PresencaBatismo[]>(`view/presencabusca/1/${params?.idevento}/${params?.idsubevento}`)
    .then(
      (sucesso) => {
        if (params?.presenca) {
          /*@ts-ignore */
          setListCheckinMembros(sucesso?.data?.filter(el => el?.presenca));
          setPagina(1);
          return;
        }
        setListCheckinMembros(sucesso?.data);
        setPagina(1);
      }
    )
    .catch(
      (error) => {
        console.log(error?.response);
      }
    )
  }

  return {
    listAll: listCheckinMembros,
    reset,
    nextPagina,
    list,
    pagina,
    refecth,
    getWithParams,
    getSearchPerMinisterio,
    pesquisaPorMinisterio
  };
}

export default GetPresencaBatismo;

